import React, { useState, useCallback, useEffect } from 'react';
import Chart from 'react-apexcharts';

import CircularProgress from '@material-ui/core/CircularProgress';
import { format } from 'date-fns';

import { t, number } from '~/helpers';
import api from '~/services/api';

import { formatData } from '../../utils/constants';
import * as S from './styles';

export default function Graphic({ url, title, params }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const dataFormated = formatData(data);

  const graph2 = {
    options: {
      colors: [
        '#008FFB',
        '#00E396',
        '#FEB019',
        '#FF4560',
        '#775DD0',
        '#546E7A',
      ],
      chart: {
        type: 'bar',
        stacked: true,
        stackType: '100%',
        toolbar: {
          show: false,
        },
      },
      xaxis: {
        categories: data?.map((value) =>
          url === 'dia'
            ? format(new Date(value.datahora), 'dd/MM/yyyy')
            : value.nomeposto
        ),
      },
      title: {
        text: title,
        align: 'left',
      },
      markers: {
        size: 0,
      },
      yaxis: {
        show: false,
      },
      grid: {
        show: false,
      },
      legend: {
        show: true,
      },
      tooltip: {
        enabled: true,
        x: {
          show: true,
        },
        y: {
          formatter: (value) => number(value, 0),
        },
      },
      dataLabels: {
        style: {
          fontSize: '12px',
          fontFamily: 'Helvetica, Arial, sans-serif',
          colors: ['#000000'],
        },
      },
      legend: {
        position: 'left',
      },
    },
    series: dataFormated ?? [],
  };

  const fetchData = async () => {
    try {
      setLoading(true);

      const response = await api.get(
        `dashboarddvec/${url}?${new URLSearchParams(params).toString()}`
      );

      setData(response.data);
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [params]);

  return (
    <S.GraphGrid>
      {loading ? (
        <CircularProgress
          style={{ alignSelf: 'center', justifySelf: 'center' }}
        />
      ) : (
        <Chart
          options={graph2.options}
          series={graph2.series}
          type="bar"
          height="100%"
          width="100%"
        />
      )}
    </S.GraphGrid>
  );
}
